import RoomPage from '../RoomPage';

const ServantRoom = () => {
  return (
    <RoomPage
      roomName="Servant"
      roomTitle="話を聞く"
      description="答えを出すのではなく、ただ聞く。言葉にならないものも含めて、あなたの話を受け止める時間。急がない、焦らない、そんな対話の場。"
      heroGradient={{
        from: '#0A3544',
        to: '#0E4454',
      }}
      works={[
        {
          title: '1on1セッション',
          description: '静かに話を聞く、個別の時間',
        },
        {
          title: '壁打ち相談',
          description: '考えを整理するためのゆるい対話',
        },
        {
          title: 'ゆる募集',
          description: 'ゆるい募集をして、人と繋がります。',
        },
        {
          title: 'ディスカッション',
          description: 'ディスカッションをして、考えを深めます。',
        },
      ]}
    />
  );
};

export default ServantRoom;